import React from 'react';

const SvgComponent = props => (
  <svg id={'ic__not_found__1'} viewBox={'0 0 378.269 250.878'} {...props}>
    <defs>
      <style>
        {
          '.prefix__cls-1{fill:#69d6d6;opacity:.1}.prefix__cls-2{fill:#104eb2}.prefix__cls-4{fill:none;stroke:#63d8f1;stroke-miterlimit:10;stroke-width:5px}.prefix__cls-5{fill:#63d8f1}'
        }
      </style>
    </defs>
    <g
      id="prefix__Grupo_559"
      data-name="Grupo 559"
      transform="translate(-450.658 -229.954)"
    >
      <path
        id="prefix__Trazado_188"
        d="M371.654 114.464h-37.609a109.976 109.976 0 00-177.835-67.8h-37.957a16.74 16.74 0 00-16.71 16.71 16.816 16.816 0 0013.918 16.492h27.05A18.285 18.285 0 01160.748 98.1v2.051a18.285 18.285 0 01-18.237 18.237H88.41A16.74 16.74 0 0071.7 135.1a16.74 16.74 0 0016.71 16.71h28.839a109.968 109.968 0 00176.089 66.753 16.287 16.287 0 004.407.611h42.583a16.74 16.74 0 0016.71-16.71 16.74 16.74 0 00-16.71-16.71H315.2a17.894 17.894 0 01-17.844-17.845v-2.356A17.894 17.894 0 01315.2 147.71h40.357a15.368 15.368 0 012.88.262h13.132a16.74 16.74 0 0016.71-16.71 16.656 16.656 0 00-16.625-16.798z"
        className="prefix__cls-1"
        data-name="Trazado 188"
        transform="translate(410.24 238.795)"
      />
      <g id="prefix__internet" transform="translate(586.262 317.315)">
        <path
          id="prefix__Trazado_475"
          d="M92.767 8.949H4.363A4.369 4.369 0 000 13.313v74.821A4.369 4.369 0 004.363 92.5h88.4a4.369 4.369 0 004.363-4.363V13.313a4.369 4.369 0 00-4.363-4.364zM2.656 13.313a1.709 1.709 0 011.707-1.707h88.4a1.709 1.709 0 011.707 1.707V24.1H2.656zm90.111 76.529H4.363a1.709 1.709 0 01-1.707-1.708V26.757h91.818v61.377a1.709 1.709 0 01-1.707 1.708z"
          className="prefix__cls-2"
          data-name="Trazado 475"
          transform="translate(0 -8.949)"
        />
        <path
          id="prefix__Trazado_476"
          d="M15.3 18.933h-4.555a1.328 1.328 0 100 2.656H15.3a1.328 1.328 0 100-2.656z"
          className="prefix__cls-2"
          data-name="Trazado 476"
          transform="translate(-2.271 -11.357)"
        />
        <path
          id="prefix__Trazado_477"
          d="M32.151 18.933H27.6a1.328 1.328 0 000 2.656h4.553a1.328 1.328 0 100-2.656z"
          className="prefix__cls-2"
          data-name="Trazado 477"
          transform="translate(-6.336 -11.357)"
        />
        <path
          id="prefix__Trazado_478"
          d="M49 18.933h-4.55a1.328 1.328 0 000 2.656H49a1.328 1.328 0 000-2.656z"
          className="prefix__cls-2"
          data-name="Trazado 478"
          transform="translate(-10.4 -11.357)"
        />
      </g>
      <circle
        id="prefix__Elipse_169"
        cx={31}
        cy={31}
        r={31}
        data-name="Elipse 169"
        transform="translate(636 349)"
        fill="#f0fbfb"
      />
      <path
        id="prefix__Trazado_186"
        d="M32.984 111.764H15.139A15.213 15.213 0 010 96.581v-3.142A15.2 15.2 0 0115.139 78.3h17.8A15.176 15.176 0 0148.08 93.439v3.141a15.148 15.148 0 01-15.096 15.184z"
        className="prefix__cls-1"
        data-name="Trazado 186"
        transform="translate(450.658 207.115)"
      />
      <path
        id="prefix__Trazado_187"
        d="M789.74 430.62h-17.8a15.175 15.175 0 01-15.14-15.139v-3.141a15.175 15.175 0 0115.139-15.14h17.8a15.176 15.176 0 0115.139 15.14v3.141a15.2 15.2 0 01-15.138 15.139z"
        className="prefix__cls-1"
        data-name="Trazado 187"
        transform="translate(24.047 27.35)"
      />
      <circle
        id="prefix__Elipse_149"
        cx={6.733}
        cy={6.733}
        className="prefix__cls-4"
        data-name="Elipse 149"
        transform="translate(539.358 232.454)"
        r={6.733}
      />
      <circle
        id="prefix__Elipse_150"
        cx={9.589}
        cy={9.589}
        className="prefix__cls-4"
        data-name="Elipse 150"
        transform="translate(702.787 242.248)"
        r={9.589}
      />
      <circle
        id="prefix__Elipse_151"
        cx={6.733}
        cy={6.733}
        className="prefix__cls-4"
        data-name="Elipse 151"
        transform="translate(746.705 330.644)"
        r={6.733}
      />
      <path
        id="prefix__Trazado_189"
        d="M684.444 94.85h-10.405V84.444a2.244 2.244 0 00-4.489 0V94.85h-10.406a2.244 2.244 0 000 4.489h10.406v10.406a2.244 2.244 0 004.489 0V99.339h10.406a2.264 2.264 0 002.244-2.244 2.232 2.232 0 00-2.245-2.245z"
        className="prefix__cls-5"
        data-name="Trazado 189"
        transform="translate(96.844 190.754)"
      />
      <path
        id="prefix__Trazado_190"
        d="M232.2 208.45h-10.41v-10.406a2.244 2.244 0 10-4.489 0v10.406h-10.457a2.244 2.244 0 100 4.489h10.406v10.406a2.244 2.244 0 004.489 0v-10.406h10.406a2.264 2.264 0 002.244-2.244 2.188 2.188 0 00-2.189-2.245z"
        className="prefix__cls-5"
        data-name="Trazado 190"
        transform="translate(318.437 135.099)"
      />
      <path
        id="prefix__Trazado_191"
        d="M733.345 261l-5.713-5.713 5.713-5.713a1.731 1.731 0 00-2.448-2.448l-5.713 5.713-5.713-5.713a1.731 1.731 0 00-2.448 2.448l5.713 5.713-5.714 5.713a1.731 1.731 0 002.448 2.448l5.713-5.713 5.713 5.713a1.756 1.756 0 002.448 0 1.667 1.667 0 00.001-2.448z"
        className="prefix__cls-5"
        data-name="Trazado 191"
        transform="translate(67.633 110.199)"
      />
      <g
        id="prefix__Grupo_230"
        data-name="Grupo 230"
        transform="translate(568.008 422.268)"
      >
        <g id="prefix__Grupo_229" data-name="Grupo 229">
          <path
            id="prefix__Trazado_195"
            d="M306.1 380.472h130.86c3.269 0 3.269-5.072 0-5.072H306.1c-3.269 0-3.269 5.072 0 5.072z"
            className="prefix__cls-5"
            data-name="Trazado 195"
            transform="translate(-303.65 -375.4)"
          />
        </g>
      </g>
      <g
        id="prefix__Grupo_232"
        data-name="Grupo 232"
        transform="translate(715.773 422.268)"
      >
        <g id="prefix__Grupo_231" data-name="Grupo 231">
          <path
            id="prefix__Trazado_196"
            d="M568.3 380.472h9.3c3.269 0 3.269-5.072 0-5.072h-9.3c-3.269 0-3.269 5.072 0 5.072z"
            className="prefix__cls-5"
            data-name="Trazado 196"
            transform="translate(-565.85 -375.4)"
          />
        </g>
      </g>
      <g
        id="prefix__Grupo_234"
        data-name="Grupo 234"
        transform="translate(523.036 422.268)"
      >
        <g id="prefix__Grupo_233" data-name="Grupo 233">
          <path
            id="prefix__Trazado_197"
            d="M226.3 380.472h29.192c3.269 0 3.269-5.072 0-5.072H226.3c-3.269 0-3.269 5.072 0 5.072z"
            className="prefix__cls-5"
            data-name="Trazado 197"
            transform="translate(-223.85 -375.4)"
          />
        </g>
      </g>
      <g
        id="prefix___002-alert"
        data-name="002-alert"
        transform="translate(638.365 351.174)"
      >
        <path
          id="prefix__Trazado_207"
          d="M28.165 0A28.165 28.165 0 1056.33 28.165 28.2 28.2 0 0028.165 0zm0 54.163a26 26 0 1126-26 26.029 26.029 0 01-26 26z"
          className="prefix__cls-2"
          data-name="Trazado 207"
        />
        <path
          id="prefix__Trazado_208"
          d="M26.083 10A1.083 1.083 0 0025 11.083v23.832a1.083 1.083 0 102.167 0V11.083A1.083 1.083 0 0026.083 10z"
          className="prefix__cls-2"
          data-name="Trazado 208"
          transform="translate(2.082 .833)"
        />
        <path
          id="prefix__Trazado_209"
          d="M26.083 37A1.083 1.083 0 0025 38.083v2.167a1.083 1.083 0 102.167 0v-2.167A1.083 1.083 0 0026.083 37z"
          className="prefix__cls-2"
          data-name="Trazado 209"
          transform="translate(2.082 3.081)"
        />
      </g>
    </g>
  </svg>
);

export default SvgComponent;
